import SectionWrapper from '@/src/components/Layouts/Section/SectionWrapper';
import { useRequest } from 'ahooks';
import React from 'react';

import { get } from 'lodash';

import CountWords from '@/src/components/CountWords/CountWords';
import ItemWrapper from '@/src/components/Layouts/Item/Item';
import Row from '@/src/components/Layouts/Row/Row';
// import FormItem from '../../components/FormItem/FormItem';

import Select from '@/src/components/Antd/Select/Select';
import Configuration from '@/src/components/Configuration/Configuration';
import { generateOptions } from 'src/components/Antd/Select/tools';
import { getActiveWarehouse } from 'src/request/common';
import { generateErrorKey } from 'src/tools/helper';

import {
  DatePicker,
  Input,
  NumberInput,
  TextArea,
} from '@/src/components/Antd';
import { useDispatch, useSelector } from 'react-redux';
import { EnumMode } from 'src/components/Antd/NumberInput/NumberInput';
import AddSupplier from 'src/constrains/SingleAddModal/AddUnit';
import { useI18n } from 'src/hooks/useRouterChange';
import useService from 'src/pages/Currency/service';
import { formatNumber } from 'src/tools/helper';
import { i18nGet } from 'src/tools/tools';
import { addSup, getInfo, setInfo } from '../slice';

import css from './css.less';

const StockInfo = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { setShowModal, setModalTitle, setModalContent, title, disabled } =
    props;
  const { reportingCurrency } = useService(true);
  const _d = useDispatch();
  const suppliers = useSelector((store: any) => {
    return store.stock.suppliers;
  });
  const _info = useSelector(getInfo());
  const {
    supplier,
    stockInDate,
    total,
    orderNo,
    notes,
    warehouse = {},
  } = _info;
  const { uuid: supplierUuid } = supplier || {};

  const { data: activatedWarehouse = [] } = useRequest(() =>
    getActiveWarehouse(),
  );

  const supplierOnSubmit = (supplier) => {
    _d(addSup({ name: supplier }));
  };
  const infoOnChange = (obj) => {
    _d(setInfo(obj));
  };
  const supplierAdd = () => {
    setShowModal(true);
    setModalTitle(getI18n('stockIn.stock.detail_stockinfo_supplierAdd'));

    const child = (
      <Row
        elements={[
          {
            child: (
              <AddSupplier
                title={getI18n('stockIn.stock.detail_stockinfo_Supplier')}
                setModal={setShowModal}
                onSubmit={supplierOnSubmit}
              />
            ),
          },
        ]}
      />
    );
    setModalContent(child);
  };
  const supplierOnChange = (value, option) => {
    infoOnChange({
      supplier: { name: option['data-label'], uuid: value },
    });
  };
  const dataOnChange = (mDate, dateString) => {
    infoOnChange({
      stockInDate: dateString,
    });
  };
  const totalOnChange = (total, e) => {
    infoOnChange({
      total,
    });
  };
  const orderNoOnChange = (orderNo, e) => {
    infoOnChange({
      orderNo,
    });
  };
  const noteOnChange = (notes, e) => {
    infoOnChange({
      notes,
    });
  };

  const warehouseOnChange = (warehouseUuid) => {
    infoOnChange({
      warehouse: { uuid: warehouseUuid },
    });
  };

  return (
    <SectionWrapper
      isHeader
      //titleClassName={css.titleContainer}
      title={
        title
        // <div className={css.itemContainer}>
        //   <p className={css.titleText}>{title}</p>
        // </div>
      }>
      <Row
        elements={[
          {
            child: (
              <ItemWrapper
                title={`${getI18n(
                  'stockIn.stock.detail_stockinfo_Supplier',
                )}*`}>
                <Select
                  error={_info[generateErrorKey('supplier')]}
                  optionsList={generateOptions(suppliers, 'name', 'uuid')}
                  size='large'
                  disabled={disabled}
                  value={supplierUuid}
                  onChange={supplierOnChange}
                  // suffixIcon={<Icon type='icondown' />}
                  rightBtn={{
                    type: 'add',
                    disabled: disabled,
                    addButtonClassName: css.addButton,
                    clickFun: supplierAdd,
                  }}
                />
              </ItemWrapper>
            ),
          },
          {
            child: (
              <ItemWrapper
                title={`${getI18n(
                  'stockIn.stock.detail_stockinfo_add_to_warehouse_title',
                )}*`}>
                <Select
                  error={_info[generateErrorKey('warehouse')]}
                  optionsList={generateOptions(
                    activatedWarehouse,
                    'locationName',
                    'uuid',
                  )}
                  size='large'
                  disabled={disabled}
                  value={get(warehouse, 'uuid', '')}
                  // suffixIcon={<Icon type='icondown' />}
                  onChange={warehouseOnChange}
                />
              </ItemWrapper>
            ),
          },
        ]}
      />
      <Row
        elements={[
          {
            child: (
              <ItemWrapper
                title={getI18n(
                  'stockIn.stock.stocklistconfig_columns_invoiceDate_title',
                )}>
                <DatePicker
                  size='large'
                  disabled={disabled}
                  onChange={dataOnChange}
                  value={stockInDate}
                />
              </ItemWrapper>
            ),
          },
          {
            child: (
              <ItemWrapper
                title={getI18n(
                  'stockIn.stock.detail_stockinfo_invoice_value_title',
                )}>
                <NumberInput
                  size='large'
                  placeholder='0.0'
                  suffix={reportingCurrency || 'HKD'}
                  min={0}
                  disabled={disabled}
                  onChange={totalOnChange}
                  value={formatNumber(total)}
                  mode={EnumMode.money}
                />
              </ItemWrapper>
            ),
          },
        ]}
      />
      <Row
        elements={[
          {
            child: (
              <ItemWrapper
                title={getI18n(
                  'stockIn.stock.detail_stockinfo_invoice_No_title',
                )}
                rightSubTitle={getI18n(
                  'stockIn.stock.detail_stockinfo_invoice_No_rightSubTitle',
                )}
                rightPart={
                  <CountWords count={(orderNo || '').length} allCount={50} />
                }>
                <Input
                  size='large'
                  disabled={disabled}
                  maxLength={50}
                  onChange={orderNoOnChange}
                  value={orderNo}
                />
              </ItemWrapper>
            ),
          },
          {
            child: (
              <ItemWrapper
                title={getI18n('stockIn.stock.detail_stockinfo_notes_title')}
                rightPart={
                  <CountWords count={(notes || '').length} allCount={500} />
                }>
                <TextArea
                  autoSize={{ minRows: 1, maxRows: 5 }}
                  size='large'
                  disabled={disabled}
                  onChange={noteOnChange}
                  value={notes}
                  maxLength={500}
                />
              </ItemWrapper>
            ),
          },
        ]}
      />
      <Row
        elements={[
          {
            child: (
              <Configuration
                configStart={getI18n(
                  'stockIn.stock.detail_stockinfo_configStart',
                )}
                linkTo={'/settings/product'}
                configLink={getI18n(
                  'stockIn.stock.detail_stockproductselection_Product',
                )}
                configEnd={getI18n('stockIn.stock.page')}
              />
            ),
          },
        ]}
      />
    </SectionWrapper>
  );
};
export default StockInfo;
